import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(0, 0, 0, .6)',
      zIndex: 1200,
    },
    content: {
      width: '80%',
      height: '70%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    closeBtn: {
      position: 'absolute',
      top: 30,
      right: 40,
      cursor: 'pointer',
      zIndex: 20,
    },
  }),
);
export default useStyles;
